var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleCardIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 135,
  height: 84,
  viewBox: "0 0 135 84",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M108.371 71.786h14.3a1.8 1.8 0 0 0 1.785-2.03L116.671 9l-8.3 62.786z",
  id: "eqein30yca"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.585 80.494c36.815 0 66.659-3.065 66.659-6.846 0-3.782-29.844-6.846-66.659-6.846-36.814 0-66.658 3.064-66.658 6.846 0 3.78 29.844 6.846 66.658 6.846z",
  fill: "#CDCEFA"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  strokeWidth: 0.9,
  transform: "matrix(-1 0 0 1 134.283 1)"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#979797",
  fill: "#0E3474",
  xlinkHref: "#eqein30yca"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#0E3474",
  xlinkHref: "#eqein30yca"
})), /*#__PURE__*/React.createElement("path", {
  d: "m106.577 10.592 10.05 60.877a1.8 1.8 0 0 1-1.753 2.093l-87.112 1.1a1.8 1.8 0 0 1-1.806-1.555l-8.49-61.978a1.8 1.8 0 0 1 1.784-2.044H104.8a1.8 1.8 0 0 1 1.776 1.507z",
  stroke: "#0E3474",
  strokeWidth: 0.9,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.465,
  fill: "#CCD8FF",
  d: "M21.23 38.612h89.973l-1.96-11.87H19.606z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.194 38.604H21.238L19.614 26.75h89.623l1.957 11.854zm-89.97.015h89.988l-.001-.009-1.96-11.875H19.595l.001.008 1.627 11.876z",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "m106.577 10.592 2.667 16.15H19.605L17.466 11.13a1.8 1.8 0 0 1 1.784-2.044H104.8a1.8 1.8 0 0 1 1.776 1.507z",
  stroke: "#0E3474",
  strokeWidth: 0.9,
  fill: "#CCD8FF",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.695 26.822c16.606 0 31.638-.027 45.095-.08l-90.439-.187c13.63.178 28.744.267 45.344.267z",
  stroke: "#0E3474",
  strokeWidth: 0.9,
  fill: "#6467EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.375 38.612c0-.044-20.177-.08-45.074-.08-24.889 0-45.07.036-45.07.08",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.375 38.612c0-.044-20.177-.08-45.074-.08-24.889 0-45.07.036-45.07.08",
  stroke: "#0E3474",
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.205 49.532c0-.044-20.177-.08-45.074-.08-24.889 0-45.07.036-45.07.08",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.205 49.532c0-.044-20.177-.08-45.074-.08-24.889 0-45.07.036-45.07.08",
  stroke: "#0E3474",
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.035 60.452c0-.044-20.176-.08-45.074-.08-24.888 0-45.07.036-45.07.08",
  fill: "#263238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.035 60.452c0-.044-20.176-.08-45.074-.08-24.888 0-45.07.036-45.07.08",
  stroke: "#0E3474",
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.222 73.164c.044-.007-1.604-10.405-3.68-23.222-2.078-12.821-3.798-23.206-3.842-23.2M90.35 73.164c.044-.007-1.604-10.405-3.68-23.222-2.078-12.821-3.798-23.206-3.843-23.2M77.46 72.7c.044-.007-1.587-10.302-3.643-22.99-2.057-12.693-3.76-22.974-3.805-22.968M64.704 73.067c.044-.007-1.6-10.383-3.673-23.174-2.073-12.794-3.789-23.157-3.833-23.15M51.889 73.067c.044-.007-1.6-10.383-3.672-23.174-2.074-12.794-3.79-23.157-3.834-23.15M39.085 73.135c.044-.007-1.602-10.399-3.678-23.208-2.076-12.813-3.795-23.191-3.84-23.185",
  stroke: "#0E3474",
  strokeWidth: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.025 56.633s-.12 9.112 2.24 14.57l14.384-2.39s-4.333-8.633-3.153-13.433l-13.47 1.253z",
  fillOpacity: 0.403,
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.024 56.215s1.807 11.079 2.914 14.38l14.339-2.724s-2.949-10.724-2.91-13.708l-14.343 2.052z",
  fill: "#6467EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.885 59.34c.011.047-2.157.493-4.841.994-2.686.502-4.872.87-4.883.823-.011-.047 2.156-.492 4.842-.994 2.685-.502 4.87-.87 4.882-.823M87.199 61.774c.011.048-2.157.493-4.842.995-2.686.502-4.871.87-4.882.823-.012-.048 2.156-.493 4.842-.995 2.685-.502 4.87-.87 4.882-.823M85.003 64.213c.005.027-.288.119-.767.246-.479.126-1.143.288-1.88.453-.736.166-1.405.305-1.89.396-.487.09-.79.133-.796.105-.005-.027.289-.12.767-.246.48-.126 1.144-.288 1.88-.453a55.075 55.075 0 0 1 1.891-.396c.486-.09.79-.133.795-.105",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.13 38.916s-1.626 9.662.02 15.823l15.889-.328s-3.251-9.838-1.193-14.756l-14.717-.739z",
  fillOpacity: 0.257,
  fill: "#0E3474"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.354 38.612s.107 12.124.751 15.823l15.875-.72s-1.395-11.918-.858-15.103H30.354z",
  fill: "#6467EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.843 43.924c0 .126-2.388.236-5.332.246-2.946.011-5.334-.082-5.334-.208 0-.125 2.387-.235 5.333-.245 2.945-.011 5.333.082 5.333.207M43.53 46.359c0 .125-2.388.235-5.333.245-2.946.011-5.333-.082-5.333-.207 0-.125 2.387-.235 5.333-.246 2.944-.01 5.332.083 5.332.208M40.706 48.801c0 .063-.333.12-.873.164-.539.043-1.284.07-2.107.074-.823.003-1.568-.02-2.107-.059-.54-.039-.873-.094-.873-.157 0-.062.333-.121.873-.164.539-.042 1.284-.071 2.107-.074.823-.003 1.568.02 2.107.059.54.04.873.094.873.157",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.369 14.803c1.133-2.05 1.499-4.558 1.003-6.878-.651-3.05-2.729-5.537-5.292-6.334-2.182-.678-6.078-.294-7.915 2.682-1.43 2.316-1.28 4.715-1.272 4.816.035.503.481.881 1.003.849a.924.924 0 0 0 .875-.97c-.002-.037-.103-1.956 1.009-3.758 1.418-2.298 4.525-2.253 5.725-1.88 2.193.682 3.601 2.985 4.024 4.965.407 1.908.11 3.966-.82 5.646-.925 1.676-2.797 2.716-4.457 2.468-.51-.076-.994.266-1.073.764a.917.917 0 0 0 .788 1.04c.26.04.522.058.784.058 2.217 0 4.445-1.346 5.618-3.468zM58.152 14.803c1.134-2.05 1.499-4.558 1.003-6.878-.651-3.05-2.729-5.537-5.292-6.334-2.182-.678-6.078-.294-7.915 2.682-1.43 2.316-1.279 4.715-1.272 4.816.036.503.482.881 1.003.849a.924.924 0 0 0 .875-.97c-.002-.037-.102-1.956 1.01-3.758 1.417-2.298 4.524-2.253 5.724-1.88 2.193.682 3.602 2.985 4.024 4.965.408 1.908.11 3.966-.819 5.646-.926 1.676-2.798 2.716-4.458 2.468-.51-.076-.994.266-1.073.764a.917.917 0 0 0 .788 1.04c.26.04.522.058.785.058 2.216 0 4.444-1.346 5.617-3.468z",
  stroke: "#0E3474",
  strokeWidth: 0.9,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCD8FF",
  d: "m32.934 9.55.864 4.564H21.06l-1.13-4.518zM54.717 9.55l.865 4.564H42.843l-1.13-4.518z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.59 17.545c0 1.085.906 1.964 2.024 1.964 1.119 0 2.025-.88 2.025-1.964 0-1.085-.906-1.965-2.025-1.965-1.118 0-2.025.88-2.025 1.965M49.372 17.545c0 1.085.907 1.964 2.025 1.964 1.119 0 2.025-.88 2.025-1.964 0-1.085-.906-1.965-2.025-1.965-1.118 0-2.025.88-2.025 1.965M93.489 18.271c2.216 0 4.444-1.346 5.617-3.468 1.133-2.05 1.5-4.558 1.003-6.878-.651-3.05-2.729-5.537-5.292-6.334-2.182-.678-6.078-.294-7.915 2.682-1.43 2.316-1.279 4.715-1.272 4.816.036.503.482.881 1.003.849a.924.924 0 0 0 .875-.97c-.002-.037-.103-1.956 1.01-3.758 1.417-2.298 4.524-2.253 5.725-1.88 2.193.682 3.6 2.985 4.023 4.965.408 1.908.11 3.966-.819 5.646-.926 1.676-2.798 2.716-4.458 2.468-.51-.076-.994.266-1.073.764a.917.917 0 0 0 .788 1.04c.26.04.523.058.785.058M74.95 18.271c2.216 0 4.444-1.346 5.617-3.468 1.133-2.05 1.5-4.558 1.003-6.878-.651-3.05-2.729-5.537-5.292-6.334-2.182-.678-6.078-.294-7.915 2.682-1.43 2.316-1.279 4.715-1.272 4.816.036.503.482.881 1.003.849a.924.924 0 0 0 .875-.97c-.002-.037-.102-1.956 1.01-3.758 1.417-2.298 4.524-2.253 5.725-1.88 2.193.682 3.6 2.985 4.023 4.965.408 1.908.11 3.966-.819 5.646-.926 1.676-2.797 2.716-4.458 2.468-.51-.076-.994.266-1.073.764a.917.917 0 0 0 .788 1.04c.26.04.523.058.785.058",
  stroke: "#0E3474",
  strokeWidth: 0.9,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.326 17.545c0 1.085.907 1.964 2.026 1.964 1.118 0 2.024-.88 2.024-1.964 0-1.085-.906-1.965-2.024-1.965-1.119 0-2.026.88-2.026 1.965M71.787 17.545c0 1.085.907 1.964 2.026 1.964 1.118 0 2.025-.88 2.025-1.964 0-1.085-.907-1.965-2.025-1.965-1.119 0-2.026.88-2.026 1.965",
  stroke: "#0E3474",
  strokeWidth: 0.9,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCD8FF",
  d: "m95.503 9.55.864 4.564H83.63l-1.13-4.518zM76.964 9.55l.864 4.564H65.09l-1.13-4.518z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleCardIcon);
export default ForwardRef;